import type { BadgeColor } from './badge-color'

import styles from './badge.module.css'

export const BADGE_FILL_CLASS: Record<BadgeColor, string> = {
  white: styles.fillWhite,
  'acorns-stone': styles.fillAcornsStone,
  'acorns-purple': styles.fillAcornsPurple,
  'acorns-forest-tint': styles.fillAcornsForestTint,
  'acorns-sunrise-tint': styles.fillAcornsSunriseTint,
  'acorns-bark-tint': styles.fillAcornsBarkTint,
  'acorns-moss-tint': styles.fillAcornsMossTint,
  'acorns-error-tint': styles.fillAcornsErrorTint,
}
